<template>
  <b-overlay :show="loading">
    <div class="d-flex justify-content-center align-items-center">
      <CheckPermission permission="*">
        <b-button
          variant="secondary"
          class="btn-icon rounded-circle p-3 mr-3"
          size="sm"
          @click="showDetails(file)"
          data-cy="details"
        >
          <feather-icon icon="SearchIcon" />
        </b-button>
      </CheckPermission>
      <div v-tooltip="'Desplegar acciones'" v-if="view === 'recibidos'">
        <b-dropdown
          variant="link"
          no-caret
          right
        >
          <template #button-content>
            <feather-icon
              data-cy="gear-button"
              width="24px"
              height="24px"
              icon="SettingsIcon"
              class="align-middle text-body"
            />
          </template>
          <CheckPermission permission="ED101">
            <b-dropdown-item
              data-cy="convert-a-file"
              v-on:click="convertFile()"
            >
              <vs-icon icon="description"/>
              Convertir a Expediente
            </b-dropdown-item>
          </CheckPermission>
          <b-dropdown-item
            data-cy="mark-read"
            v-on:click="markRead()"
            v-if="view === 'recibidos'"
          >
            <vs-icon icon="thumb_up"/>
            Acuse recibo
          </b-dropdown-item>
          <b-dropdown-item
            data-cy="mark-return"
            v-if="view === 'recibidos'"
            v-b-modal="`modal-process-${file.id}`"
            v-on:click="returnFile()"
          >
            <vs-icon icon="reply"/>
            Devolver
          </b-dropdown-item>
        </b-dropdown>
        <span />
      </div>
      <b-modal
        :id="`modal-process-${file.id}`"
        :title="`${titleModal} el documento #${file.id}`"
        ok-title="Vale"
        size="lg"
        :ref="`modal-process-${file.id}`"
        hide-footer
      >
        <ModalProcessDD
          :file="file"
          :process="processAction"
          @close-modal="closeModal"
        />
      </b-modal>
    </div>
  </b-overlay>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';
import { BModal } from 'bootstrap-vue';

import CheckPermission from '@/febos/global/usuario/components/CheckPermission';
import { listOptions } from '@/febos/servicios/api/opciones.api';
import { updateFileDD, listOptions as getFileEDFromDocDigital } from '@/febos/servicios/api/docDigital.api';
import { ALERT_POSITION } from '@/febos/global/utils/configurations';
import { GORE_VALPARAISO } from '@/constants/companies';
import ModalProcessDD from '@/febos/chile/docDigital/components/ModalProcessDD';

export default {
  data() {
    return {
      loading: false,
      view: this.$route.params.view,
      uploadedFiles: [],
      processAction: '',
    };
  },
  components: { BModal, ModalProcessDD, CheckPermission },
  computed: {
    ...mapGetters('Empresas', ['company']),
    ...mapGetters('Usuario', ['currentUserId']),
    isConvention() {
      return this.company.iut === '60100003-2';
    },
    isAguasAndinas() {
      return this.company.iut === '61808000-5';
    },
    isSiss() {
      return this.company.iut === '61221000-4';
    },
    isGore() {
      return this.company.iut === GORE_VALPARAISO.iut;
    },
    titleModal() {
      if (this.processAction === 'return') {
        return 'Devolver';
      }
      return 'Dar acuse recibo';
    }
  },
  methods: {
    ...mapActions('Modals', ['showModals']),
    ...mapActions('docDigital', ['getDocDigitalFiles']),
    ...mapActions('Dnts', ['setWizardStorageFile']),
    async convertFileDefaultEnterprises() {
      try {
        this.loading = true;
        const response = await listOptions({
          grupoOpcion: 'tipos.documentos-ed',
          deshabilitado: 'no'
        });
        let externDocument = {};
        const document = response.data.opciones
          .find((docOption) => {
            const posibleDescription = docOption.extra && JSON.parse(docOption.extra);
            if (posibleDescription && posibleDescription.ddNombres) {
              return posibleDescription.ddNombres.includes(this.file.typeDescription);
            }
            return docOption.descripcion.includes(this.file.typeDescription) || (`${docOption.descripcion}s`).includes(this.file.typeDescription);
          });
        if (this.isSiss || this.isGore) {
          const moreDocuments = await listOptions({
            grupoOpcion: 'tipos.documentos.externos-ed',
            deshabilitado: 'no'
          });
          externDocument = moreDocuments.data.opciones
            .find((docOption) => {
              const posibleDescription = docOption.extra && JSON.parse(docOption.extra);
              if (posibleDescription && posibleDescription.ddNombres) {
                return posibleDescription.ddNombres.includes(this.file.typeDescription);
              }
              if (this.file.typeDescription === 'Memorando') {
                return docOption.descripcion.includes('Memo');
              }
              return docOption.descripcion.includes(this.file.typeDescription);
            });

          if (!externDocument) {
            this.$vs.notify({
              title: 'Error',
              text: 'No se encontró el tipo de descripción en la configuración del documento',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger',
              position: ALERT_POSITION
            });
            return;
          }
        }

        const documentsFromDocDigital = [
          {
            url: this.file.url,
            tipo: 'principal'
          }
        ];
        if (this.file.relatedDocuments.length) {
          this.file.relatedDocuments.forEach((documentED) => documentsFromDocDigital.push({
            url: documentED.url,
            name: documentED.name,
            tipo: 'adjunto'
          }));
        }

        // Dividir en lotes de 5 para evitar timeout cuando hay muchos documentos
        const batchSize = 5;
        const batches = [];
        for (let i = 0; i < documentsFromDocDigital.length; i += batchSize) {
          batches.push(documentsFromDocDigital.slice(i, i + batchSize));
        }

        const batchResponses = await Promise.all(
          batches.map((batch) =>
            getFileEDFromDocDigital({
              params: {
                metodo: 'get_file_expedientes'
              },
              body: batch
            }))
        );

        // Unir las respuestas de todos los lotes
        const responseAttachments = {
          data: {
            respuesta: batchResponses.reduce((acc, res) => {
              if (res.data?.respuesta) {
                return acc.concat(res.data.respuesta);
              }
              return acc;
            }, [])
          }
        };

        let fileWizard = {
          dnt: {
            emisorCentroCostoNumero: (this.isSiss || this.isGore)
              ? externDocument.valor : document.valor,
            emisorSucursalPais: (this.isSiss || this.isGore)
              ? externDocument.opcionId : document.opcionId,
            emisorCentroCostoNombre: this.file.typeDescription,
            numeroInt: this.file.folio,
            emisorContactoCodigo: `${ this.file.creatorEntityId}`,
            emisorContactoArea: this.file.creatorEntityName,
            compradorCodigo: 'DD',
            compradorArea: 'Doc Digital',
            nombreDescriptivo: this.file.theme,
            fechaEmision: this.$moment(this.file.createdAt, 'DD-MM-YYYY HH:mm').toDate(),
            emisorContactoNombre: this.file.creatorName,
            despachoContactoNombre: this.file.creatorName,
            emisorContactoEmail: this.file.creatorEmail
          },
          observaciones: [
            { observacion: this.file.theme },
            { observacion: this.file.description }
          ],
          referencias: [
            {
              linea: 1,
              tipoDocumento: 'DDD',
              folio: this.file.id
            }
          ],
          ...(responseAttachments.data?.respuesta
            && { adjuntos: responseAttachments.data?.respuesta })
        };
        if (this.isGore) {
          fileWizard = {
            ...fileWizard,
            dnt: {
              ...fileWizard.dnt,
              tipoFlujo: 1,
              compradorArea: 'OES',
              compradorCodigo: 'Organismo del estado',
              emisorCentroCostoNumero: externDocument.valor
            }
          };
        }
        await this.setWizardStorageFile(fileWizard);
        if (this.isGore) {
          await this.$router.push('/documentos/ddExterno');
        } else {
          await this.$router.push('/documentos/ddExterno');
        }
      } finally {
        this.loading = false;
      }
    },
    async getFileUrls() {
      const mainFile = await this.getDocDigitalFiles({
        params: { metodo: 'get_file' },
        url: this.file.url,
        name: 'archivo_principal.pdf'
      });
      this.uploadedFiles.push({
        adjuntoId: this.file.id,
        adjuntoNombre: mainFile.name,
        adjuntoMime: mainFile.mime,
        fecha: this.$moment().format('YYYY-MM-DD HH:MM:ss'),
        adjuntoUrl: mainFile.url,
        tipoDescripcion: mainFile.name,
        tipo: 'principal'
      });

      await Promise.all(
        this.file.relatedDocuments.map(async (file) => {
          await this.getDocDigitalFiles({
            params: { metodo: 'get_file' },
            url: file.url,
            name: file.name
          }).then((response) => {
            this.uploadedFiles.push({
              adjuntoId: file.id,
              adjuntoNombre: response.name,
              adjuntoMime: response.mime,
              fecha: this.$moment().format('YYYY-MM-DD HH:MM:ss'),
              adjuntoUrl: response.url,
              tipoDescripcion: response.name,
              tipo: 'adjunto'
            });
          });
        })
      );
    },
    async convertFileForConvention() {
      try {
        this.loading = true;
        const response = await listOptions({
          grupoOpcion: 'tipos.documentos-ed',
          deshabilitado: 'no'
        });

        await this.getFileUrls();

        const document = response.data.opciones
          .find((docOption) => docOption.descripcion.includes(this.file.typeDescription));
        const fileWizard = {
          dnt: {
            emisorCentroCostoNumero: document ? document.valor : '',
            emisorCentroCostoNombre: this.file.typeDescription,
            numeroInt: this.file.folio,
            nombreDescriptivo: this.file.theme,
            fechaEmision: this.$moment(this.file.createdAt, 'DD-MM-YYYY HH:mm').toDate(),
            emisorContactoNombre: this.file.creatorName,
            emisorContactoEmail: this.file.creatorEmail,
            transporteNotas: this.file.creatorEntityName
          },
          firmantes: [...this.file.signers],
          visadores: [...this.file.certifiers],
          archivos: this.uploadedFiles,
          observaciones: [
            { observacion: this.file.theme },
            { observacion: this.file.description }
          ],
          referencias: [
            {
              linea: 1,
              tipoDocumento: 'DDD',
              folio: this.file.id
            }
          ]
        };
        await this.setWizardStorageFile(fileWizard);
        await this.$router.push({ name: 'conventionInputForm', params: { from: 'docDigital' } });
      } finally {
        this.loading = false;
      }
    },
    async convertFile() {
      if (this.isConvention) {
        await this.convertFileForConvention();
        return;
      }
      await this.convertFileDefaultEnterprises();
    },
    markRead() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: 'Heey!',
        text: 'Al confirmar, se dará acuse de recibo a este documento en DocDigital',
        cancelText: 'Cancelar',
        acceptText: 'Confirmar',
        accept: async () => {
          await updateFileDD(
            'put',
            `/api/documentos/recibidos/${this.file.id}/acusorecibo`,
            {}
          );
          this.$vs.notify({
            title: 'Genial!',
            text: 'Se ha avisado a DocDigital de este documento',
            color: 'success',
            time: 5000,
            position: 'top-center'
          });
          await this.$emit('refresh-list');
        },
        cancel: () => {}
      });
    },
    returnFile() {
      this.processAction = 'return';
    },
    showDetails() {
      this.selectFile(this.file);
      this.showModals('PopUpGeneralDetailFile');
    },
    closeModal() {
      if (this.$refs[`modal-process-${this.file.id}`]) {
        this.$refs[`modal-process-${this.file.id}`].hide();
      }
      this.$emit('refresh-list');
    }
  },
  props: [
    'file',
    'selectFile'
  ]
};

</script>
